import { FC } from 'react'
import { ColorOptions } from '../../theme/UiThemeProvider'
import { Box } from '../BoxNew'
import { Icon, IconOptions } from '../IconNew'
import { SpacerNew } from '../SpacerNew'
import { Text } from '../TextNew'
import { tabTypes } from './TabTypes'

const tabState = tabTypes.default.state

export interface TabProps {
  title?: string
  iconId?: IconOptions
  color?: ColorOptions
  onSelected: () => void
  state: keyof typeof tabState | Array<keyof typeof tabState>
  type?: keyof typeof tabTypes | Array<keyof typeof tabTypes>
  isDisabled?: boolean
}
export const Tab: FC<TabProps> = ({
  title,
  type = 'default',
  iconId,
  state = 'normal',
  onSelected,
  isDisabled = false,
}: TabProps) => {
  const currentType = tabTypes[type as keyof typeof tabTypes].state
  return (
    <Box
      disabled={isDisabled}
      {...tabTypes[type as keyof typeof tabTypes].underlayColor}
      onPress={onSelected}
      underlayColor={tabTypes[type as keyof typeof tabTypes].underlayColor as any}>
      <Box {...currentType[state as keyof typeof tabState].innerContainer}>
        {iconId && <Icon {...currentType[state as keyof typeof tabState].iconStyle} id={iconId as any} />}
        {iconId && title && <SpacerNew size="SMALLEST" direction="horizontal" />}
        {title && <Text title={title} {...currentType[state as keyof typeof tabState].textStyle} />}
      </Box>
    </Box>
  )
}
